module.exports = __webpack_public_path__ + "img/success.600be253.png";